module.exports = __webpack_public_path__ + "static/media/left.0d8e3f46.svg";